import React from 'react';

import { SortDropdown } from '@/slw/features/search-results';
import { formatNumber } from '@/slw/shared/lib/format-number';

interface ListingSummarySortTabProps {
  start: number;
  end: number;
  totalCount: number;
  sort?: string;
  onSortChange: (v: string) => void;
}

function ListingSummarySortTabComponent({
  start,
  end,
  totalCount,
  sort = 'best_match',
  onSortChange,
}: ListingSummarySortTabProps) {
  return (
    <div
      className='
          flex gap-2
          flex-row justify-between
          mb-6
          items-center
          sm:mt-4
        '
    >
      <p className='text-sm'>{`Showing ${start}–${end} of ${formatNumber(totalCount)} Listings`}</p>
      <div className='flex items-center gap-2 mt-1 md:mt-0'>
        <span className='text-sm'>Sort By</span>
        <SortDropdown value={sort} onChange={onSortChange} />
      </div>
    </div>
  );
}

export const ListingSummarySortTab = React.memo(ListingSummarySortTabComponent);
